import React from "react";
import { Container, Row, Col, Form, Button, Breadcrumb } from "react-bootstrap";

const CourseSearch = () => {
    return (
        <>
            {/* BANNER */}
            <section className="main-breadcrumb-section mb-5">
                <Container className="heading-title">
                    <h2 className="about-title text-center">
                        Main Courses
                        {/* <span className=" about-text">Us</span> */}
                    </h2>
                    <Breadcrumb>
                        <Breadcrumb.Item href="#">Home</Breadcrumb.Item>
                        <Breadcrumb.Item active className="about-text"> Courses </Breadcrumb.Item>
                        <Breadcrumb.Item href="#">Sub Courses Page</Breadcrumb.Item>
                    </Breadcrumb>
                </Container>
            </section>

            {/* SEARCH BOX */}
            <section className="search-section">
                <Container>
                    <div className="search-box-wrapper">

                        <div className="search-title">
                            Search your course
                        </div>

                   <Row className="g-4 justify-content-center">
  {/* COURSE DROPDOWN */}
  <Col lg={4} md={6} sm={12}>
    <Form.Select className="search-input">
      <option value="">Select Course</option>
      <option value="web-design">Web Design</option>
      <option value="web-development">Web Development</option>
      <option value="graphic-design">Graphic Design</option>
      <option value="digital-marketing">Digital Marketing</option>
    </Form.Select>
  </Col>

  {/* CATEGORY DROPDOWN */}
  <Col lg={4} md={6} sm={12}>
    <Form.Select className="search-input">
      <option value="">Select Category</option>
      <option value="beginner">Beginner</option>
      <option value="intermediate">Intermediate</option>
      <option value="advanced">Advanced</option>
    </Form.Select>
  </Col>

  {/* BUTTON */}
  <Col lg={3} md={6} sm={12}>
    <Button className=" btn-grad border-0 fw-bold btn btn btn-primary shadow-none w-100">
      Search Course
    </Button>
  </Col>
</Row>
                    </div>
                </Container>
            </section>
        </>
    );
};

export default CourseSearch;
